import React from 'react'
import { Modal, Typography } from 'antd'

interface IBotDisconnectModalProps {
  open: boolean
  text: string
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const BotDisconnectModal: React.FC<IBotDisconnectModalProps> = ({
  open,
  text,
  isLoading,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal
      centered
      open={open}
      title='Отключение бота'
      okText='Да'
      cancelText='Нет'
      okButtonProps={{ danger: true }}
      confirmLoading={isLoading}
      onOk={onConfirm}
      onCancel={onCancel}
    >
      <Typography.Text>{text}</Typography.Text>
    </Modal>
  )
}
